export function getSSAProductListView(adObj) {
    const adData = getSSAData(adObj);
    return `<!-- SSAProduct - Creative Id ${adObj.creativeId} -->
        <a href="_url" class="mod flex align-items-stretch man clickable userhistory 
        linkblock licorice unoverflowify" target="_blank">
        <div class="inner r-pal">
        <div class="bd">
        <div class="result-item-image">
        <div class="format3by2">
        <img src="${adData.image.url}" class="centered-image">
        </div>
        </div>
        <div class="unoverflowify">
        <div>
        <span class="result-status mtt objectstatus bg-banana valign-middle centerify"
        style="width: 100%;">Reklame</span>
        </div>
        <h3 class="t4 word-break mhn result-item-heading" data-automation-id="titleRow">${adData.title}</h3>
        <p class="t4 word-break mhn" style="line-height:1.25">${adData.text}</p>
        <p class="t5 word-break mhn inlineblockify" style="line-height:1.25">
        <span data-automation-id="bodyRow" class="prm">${adData.price},-</span>
        </p>
        <div class="fright result-item-logo-container hide-lt768 mls mts">
        <img src="${adData.logo.url}" class="result-item-logo">
        </div>
        </div>
        </div>
        </div>
        </a>`;
}

export function getSSAProductGridView(adObj) {
    const adData = getSSAData(adObj);
    return `<!-- SSAProduct - Creative Id ${adObj.creativeId} -->
        <a href="_url" class="mod flex align-items-stretch man clickable userhistory 
        linkblock licorice unoverflowify" target="_blank">
        <div class="inner r-pal">
        <div class="bd">
        <div class="result-item">
        <div class="result-media">
        <div class="format4by3">
        <img src="${adData.image.url}" class="centered-image" alt="">
        </div>
        <div class="result-media__price" style="position: absolute;bottom: 0;left: 0;">
        <p class="result-price man milk word-break">${adData.price},-</p>
        </div>
        </div>
        <div class="unoverflowify">
        <div>
        <span class="result-status mtt objectstatus bg-banana valign-middle centerify"
        style="width: 100%;">Reklame</span>
        </div>
        <h3 class="result-heading man mtm word-break">${adData.title}</h3>
        <div class="result-details mtt flex justify-space-between">
        <div>
        <span class="stone valign-middle">${adData.text}</span>
        </div>
        </div>
        <div class="fright result-item-logo-container hide-lt768 mls mts">
        <img src="${adData.logo.url}" class="result-item-logo">
        </div>
        </div>
        </div>
        </div>
        </div>
        </a>`;
}

export function getSSAContent(adObj) {
    const adData = getSSAData(adObj);
    return `<!-- SSAContent - Creative Id ${adObj.creativeId} -->
        <div class="ssa-content-ad">
            <a href="${adData.click.tracker}./clickenc=${adData.click
        .url}" class="linkblock link--block dark-links" target="_blank" rel="noopener">
                <div class="ssa-flex ssa-flex--column" style="height: 100%;">
                    <div class="ssa-flex ssa-content-ad__annonse" style="flex: 1;">ANNONSE</div>
                    <div class="ssa-flex ssa-flex--justify-space-between align-items-center ssa-content-ad__titlegroup">
                        <h3 class="man u-ma0 licorice u-licorice ssa-content-ad__heading">${adData.title}</h3>
                        <img class="blockify u-blockify ssa-content-ad__logo" width="70" height="70" src="${adData
                            .logo.url}" alt="">
                    </div>
                    <div class="flex ssa-content-ad__body">
                        <div class="ssa-content-ad__image_container" style="flex: none;">
                            <img class="blockify u-blockify ssa-content-ad__image" width="330" height="330" src="${adData
                                .image.url}" alt="">
                        </div>
                        <div class="ssa-flex ssa-flex--column ssa-flex--justify-space-between ssa-content-ad__box">
                            <p class="man u-ma0 licorice u-licorice ssa-content-ad__description">${adData.text}</p>
                            <p class="man u-ma0"><button class="primary button button--cta ssa-content-ad__cta">${adData
                                .click.label}</button></p>
                        </div>
                    </div>
                </div>
            </a>
            <img src="${adData.impression
                .tracker}" style="display: none;" alt="">
        </div>
    `;
}

export function getNetboardTemplate(adObj) {
    let iconImage = '';
    const adData = adObj.native;

    if (adData.iconImgUrl) {
        iconImage = `
        <div class="native-add__media__logo">
            <img class="native-add__media__img" src="${adData.iconImgUrl}" alt="${adData.sponsoredBy}" />
        </div>`;
    }

    return `<!-- NativeNetboard - Creative Id ${adObj.creativeId} -->
    <div class="native-add native-add-markasadd">
    <div class="native-add__wrap">
        <a href="${adData
            .clickTrackers[0]}./clickenc=${adData.clickUrl}" class="native-add__media linkblock dark-links clickable" target="_blank">
            <img class="native-add__media__img" src="${adData.mainMedia[0]
                .url}" alt="Annonsebilde" />
            <div class="native-add__media__caption">
                <div class="native-add__sponsoredBy">annonse fra ${adData.sponsoredBy}</div>
                <div class="native-add__title">${adData.title}</div>
                ${iconImage}
                <img src="${adData
                    .impressionTrackers[0]}" height="0" width="0" style="display: none;" alt="" />
            </div>
        </a>
    </div>
    </div>`;
}

// premium position
export function getContentBoardTemplate(adObj) {
    const adData = adObj.native;
    return `<!-- NativeContentBoard - Creative Id ${adObj.creativeId} -->
    <div class="mod" style="margin-left: 20px !important;">
    <div class="inner bat pvn">
        <div class="bd r-pam">
            <p class="d1 centerify mvn stone">annonse</p>
            <div class="line">
                <a href="${adData
                    .clickTrackers[0]}./clickenc=${adData.clickUrl}" class="linkblock dark-links clickable" target="_blank">
                    <div class="unit r-size1of2 r-pam">
                        <img src="${adData.mainMedia[0]
                            .url}" alt="Annonsebilde" />
                        <img src="${adData
                            .impressionTrackers[0]}" height="0" width="0" style="display: none;" alt="" />
                    </div>
                    <div class="unit r-size1of2 r-pam">
                        <h2 class="man">${adData.title}</h2>
                        <p class="man">${adData.description}</p>
                        <div class="rightify">
                            <img class="man" width="60" height="60" src="${adData.iconImgUrl}" alt="${adData.sponsoredBy}" />
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
    </div>`;
}

function formatUrl(url) {
    return url.replace(/(^\w+:|^)\/\//, '').replace(/\/$/, '');
}

function escape(text) {
    let newtext = text;
    if (typeof text === 'string') {
        newtext = text
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    }
    return newtext;
}

function getSSAData(adObj) {
    const ad = adObj.native;
    const data = {};
    data.logo = {};
    data.image = {};
    data.impression = {};
    data.click = {};
    data.click.url = escape(ad.clickUrl);
    data.click.tracker = ad.clickTrackers.length
        ? escape(ad.clickTrackers[0])
        : '';
    data.impression.tracker = ad.impressionTrackers
        ? escape(ad.impressionTrackers[0])
        : '';
    data.price = ad.custom.price ? escape(ad.custom.price) : '';
    if (ad.custom.destination_label) {
        data.click.label = escape(ad.custom.destination_label);
    } else {
        data.click.label = escape(formatUrl(ad.clickUrl));
    }
    if (ad.mainMedia && ad.mainMedia[0]) {
        data.image.url = escape(ad.mainMedia[0].url);
        data.image.height = escape(ad.mainMedia[0].height);
        data.image.width = escape(ad.mainMedia[0].width);
    }
    if (ad.iconImgUrl) {
        data.logo.url = escape(ad.iconImgUrl);
    }
    if (ad.fullText) {
        data.text = escape(ad.fullText);
    } else {
        data.text = escape(ad.description);
    }
    data.title = ad.title ? escape(ad.title) : '';

    return data;
}



// WEBPACK FOOTER //
// ./services/banner2/BannerTemplates.js